import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { faClock, faPlaneArrival, faPlaneDeparture } from '@fortawesome/free-solid-svg-icons';
import { IEnquiryFlight } from '@simplyfly/shared';
import { getEnquiryFlightFlyTimeInMin } from 'src/app/interfaces/enquiry-flight.helpers';
import { IAirport } from '@simplyfly/shared';
import { convertMinutesToTime } from 'src/app/misc.utils';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-enquiry-flights-card-mini',
    templateUrl: './enquiry-flights-card-mini.component.html',
    styleUrls: ['./enquiry-flights-card-mini.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent, DatePipe, TranslateModule]
})
export class EnquiryFlightsCardMiniComponent {
  @Input() enquiryFlight: IEnquiryFlight | null = null;
  @Input() clickable = false;
  @Input() airportsObj: { [id: string]: IAirport | null } = {};

  faPlaneDeparture = faPlaneDeparture;
  faPlaneArrival = faPlaneArrival;
  faClock = faClock;

  convertMinutesToTime = convertMinutesToTime;
  getEnquiryFlightFlyTimeInMin = getEnquiryFlightFlyTimeInMin;
}
